<template>
  <CardToolbox>
    <sdPageHeader title="Leveranciers">
      <template #subTitle>
        <span class="title-counter">{{ count }} leverancier{{ count > 0 && count < 2 ? '' : 's' }}</span>
        <AutoCompleteStyled style="width:100%" placeholder="Zoeken op naam...">
          <a-input type="input" v-model:value="search">
            <template #suffix>
              <sdFeatherIcons type="search"/>
            </template>
          </a-input>
        </AutoCompleteStyled>
      </template>
      <template #buttons>
        <SupplierAdd v-if="$can('create', 'supplier')"/>
      </template>
    </sdPageHeader>
  </CardToolbox>

  <Main>
    <a-row :gutter="15">
      <a-col :md="24">
        <SupplierListTable/>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import SupplierListTable from './component/SupplierTable';
import {computed, ref, defineComponent, onMounted, watch} from 'vue';
import {useStore} from 'vuex';
import {Main, CardToolbox, AutoCompleteStyled} from '../styled';
import SupplierAdd from "./SupplierAdd";
import locale from "@/static/locale/nl.json";

const SupplierList = defineComponent({
  name: 'SupplierList',
  components: {SupplierAdd, Main, CardToolbox, SupplierListTable, AutoCompleteStyled},
  setup() {
    const {state, dispatch} = useStore();
    const searchData = computed(() => state.headerSearchData);
    const count = computed(() => state.supplier.count);
    const selectedRowKeys = ref(0);
    const selectedRows = ref(0);
    const search = ref(state.supplier.listQuery?.q ?? null);
    let debounce = null;

    watch(search, (query) => {
      clearTimeout(debounce)
      debounce = setTimeout(async () => {
        const searchValues = {
          q: query,
          pageSize: state.supplier.pageSize,
          page: 1,
        };
        await dispatch('setCurrentPageSupplier', 1);
        await dispatch('getSuppliers', searchValues);
      }, 600);
    });

    onMounted(async () => {
      await dispatch('getSuppliers', {page: state.supplier.currentPage, pageSize: state.supplier.pageSize});
    });

    return {
      searchData,
      selectedRowKeys,
      selectedRows,
      count,
      locale,
      search,
    };
  },
});

export default SupplierList;
</script>
